import {Directive, HostBinding, ViewChild} from "@angular/core";
import {ReportPageComponent} from "./report-page.component";

@Directive()
export abstract class AbstractReportPage {
    @ViewChild(ReportPageComponent) reportPageComponent: ReportPageComponent;

    @HostBinding("style.display") private display: string = "flex";
    @HostBinding("style.width") private width: string = "100%";

    get reportParams(): any {
        return this.reportPageComponent ? this.reportPageComponent.reportParams : undefined;
    }
}
